import { InjectionToken } from "@angular/core";
import { IAppConfig } from "../interfaces/app-config";

/**
 * Injection token for the partner application config.
 */
export const APP_CONFIG = new InjectionToken<IAppConfig>("APP_CONFIG");
